var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _polygon, _polygon2, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: "182.13mm",
    height: "38.91mm",
    viewBox: "0 0 516.27 110.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.46,34.8v33.32h13.1v7.72h-23.09v-41.04h10Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182.2,76.3c-9.59,0-16.84-6.43-16.84-16.78s7.43-16.78,16.95-16.78,16.95,6.43,16.95,16.78-7.48,16.78-17.07,16.78ZM182.2,67.65c3.57,0,6.9-2.63,6.9-8.13s-3.27-8.13-6.78-8.13-6.78,2.57-6.78,8.13,3.04,8.13,6.66,8.13Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M218.99,42.75c8.19,0,13.97,4.5,15.67,12.28h-10.64c-.82-2.28-2.46-3.74-5.2-3.74-3.57,0-6.02,2.81-6.02,8.24s2.46,8.24,6.02,8.24c2.75,0,4.33-1.34,5.2-3.74h10.64c-1.7,7.54-7.48,12.28-15.67,12.28-9.59,0-16.37-6.43-16.37-16.78s6.78-16.78,16.37-16.78Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M239.99,32.57h10v23.91l9.88-13.27h12.34l-13.56,16.37,13.68,16.25h-12.39l-9.94-13.68v13.68h-10v-43.26Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M289.08,76.3c-9.59,0-16.49-6.43-16.49-16.78s6.78-16.78,16.49-16.78,16.25,6.31,16.25,16.25c0,.93-.06,1.93-.18,2.92h-22.63c.35,4.27,2.98,6.26,6.2,6.26,2.81,0,4.39-1.4,5.2-3.16h10.64c-1.58,6.37-7.37,11.28-15.49,11.28ZM282.59,56.37h12.51c0-3.57-2.81-5.61-6.14-5.61s-5.79,1.99-6.37,5.61Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M324.55,42.75c4.33,0,8.07,1.99,10.06,4.97v-15.14h10v43.26h-10v-4.68c-1.81,2.98-5.26,5.15-10.06,5.15-8.01,0-14.38-6.55-14.38-16.84s6.37-16.72,14.38-16.72ZM327.47,51.46c-3.74,0-7.13,2.81-7.13,8.01s3.39,8.13,7.13,8.13,7.13-2.86,7.13-8.07-3.33-8.07-7.13-8.07Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M350.52,32.69h28.35v5.44h-10.81v37.71h-6.66v-37.71h-10.87v-5.44Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M391.53,75.84h-6.66v-32.21h6.66v4.68c1.87-3.22,5.09-5.2,9.65-5.2v6.9h-1.7c-4.91,0-7.95,2.05-7.95,8.89v16.95Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M421.04,43.1c5.44,0,9.18,2.57,11.17,5.2v-4.68h6.72v32.21h-6.72v-4.79c-2.05,2.75-5.9,5.32-11.28,5.32-8.36,0-15.08-6.84-15.08-16.78s6.72-16.49,15.2-16.49ZM422.44,48.89c-4.97,0-9.76,3.74-9.76,10.7s4.79,10.99,9.76,10.99,9.76-3.92,9.76-10.87-4.73-10.82-9.76-10.82Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M460.13,43.1c4.21,0,8.65,1.99,11.11,5.03v-15.55h6.72v43.26h-6.72v-4.85c-2.05,2.92-5.9,5.38-11.17,5.38-8.48,0-15.2-6.84-15.2-16.78s6.72-16.49,15.26-16.49ZM461.47,48.89c-4.97,0-9.76,3.74-9.76,10.7s4.79,10.99,9.76,10.99,9.76-3.92,9.76-10.87-4.73-10.82-9.76-10.82Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M500.6,76.36c-9.24,0-16.08-6.55-16.08-16.66s6.55-16.6,16.08-16.6,15.67,6.37,15.67,15.84c0,1.11-.06,2.16-.23,3.27h-24.61c.47,5.32,4.27,8.54,9.18,8.54,4.09,0,6.37-1.99,7.6-4.5h7.19c-1.81,5.61-6.9,10.12-14.79,10.12ZM491.48,56.84h17.83c-.12-4.97-4.03-8.13-9.01-8.13-4.5,0-8.13,3.04-8.83,8.13Z",
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "129.95 .05 89.88 0 69.77 0 62.66 0 42.55 0 39.91 0 12.69 0 32.8 20.11 60.02 20.11 62.66 20.11 80.13 20.11 89.88 20.11 89.88 40.23 89.88 77.18 89.95 77.18 110 97.23 110 82.11 110 82.05 110 40.23 110 20.15 129.95 .05",
    fill: "#fff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "81.99 90.18 49.98 90.18 47.34 90.18 20.11 90.18 20.11 70.06 20.11 28.18 20.05 28.18 0 8.13 0 28.18 0 28.24 0 70.06 0 90.18 20.11 110.29 40.23 110.29 47.34 110.29 67.45 110.29 70.09 110.29 102.1 110.29 81.99 90.18",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.57,
    y: 59.07,
    width: 12.03,
    height: 21.66,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48.99,
    y: 37.86,
    width: 12.03,
    height: 42.87,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 68.44,
    y: 48.23,
    width: 12.03,
    height: 32.5,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.eb1877b57f9cb22591a6e730a04bdc5e.svg";
export { ForwardRef as ReactComponent };